import Vue from 'vue'
import FeatherIcon from '@core/components/feather-icon/FeatherIcon.vue'
import JsonCSV from 'vue-json-csv'

Vue.component(FeatherIcon.name, FeatherIcon)
Vue.component('downloadCsv', JsonCSV)
